<template>
  <div class="content-inter-box">
    <div class="white-box table-outer-box">
      <el-row>
        <el-form
          :model="formData"
          label-width="0px"
          ref="form"
          class="Waybilllist"
        >
          <el-col :span="8">
            <el-form-item class="mr20 form-item time-select">
              <span class="new-label">目的国</span>
              <el-select
                v-model="formData.BizTypeNew"
                placeholder="请选择目的国"
                class="buswidth"
                filterable
              >
                <el-option
                  v-for="item in stateLIstanbul"
                  :key="item.value"
                  :label="item.description"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="mr20 form-item time-select">
              <span class="new-label">包装类型</span>
              <el-select
                v-model="formData.sys_BizStatus"
                placeholder="请选择包装类型"
                class="buswidth"
                filterable
              >
                <el-option
                  v-for="item in packagingType"
                  :key="item.value"
                  :label="item.description"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="mr20 form-item time-select">
              <span class="new-label">重量</span>
              <el-input
                v-model="formData.StoreNo"
                placeholder="请输入重量"
                class="buswidth"
                clearable
                @input="($event) => $forceUpdate()"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="mr20 mb20 time-select">
              <span class="new-label">邮编</span>
              <el-input
                v-model="formData.MicHead"
                placeholder="请输入邮编"
                clearable
                class="buswidth"
                @input="($event) => $forceUpdate()"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item class="mr20 form-item">
              <el-button type="primary" icon="el-icon-search" @click="query()" style="height:32px"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <el-row>
        <div
          class="table-box"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          v-loading="table_loading"
        >
          <div class="table-box-tpp">
            <el-table
              id="applyTable"
              :data="tableData.list"
              border
              row-key="id"
              align="left"
              :header-cell-style="{
                background: '#eef1f6',
                color: '#606266',
              }"
            >
              <el-table-column
                label="序号"
                type="index"
                min-width="55"
              >
              </el-table-column>
              <el-table-column
                prop=""
                label="运输方式"
                min-width="160"
              >
              </el-table-column>
              <el-table-column prop="" label="邮编" min-width="100">
              </el-table-column>
              <el-table-column prop="" label="重量(KG)" min-width="100">
              </el-table-column>
              <el-table-column prop="" label="总费用(RMB)" min-width="120">
              </el-table-column>
              <el-table-column prop="" label="运费(RMB)" min-width="180">
              </el-table-column>
              <el-table-column prop="" label="派送费(RMB)" min-width="100">
              </el-table-column>
              <el-table-column prop="" label="时效" min-width="120">
              </el-table-column>
            </el-table>
          </div>
          <div class="table-b-f-b mb20">
            <el-pagination
              class="fr"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.pageIndex"
              :page-sizes="[20, 30, 50]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.totalCount"
            ></el-pagination>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { MessageTips } from "../../../base/js/mUtils";
import innerface from "./innerface";
export default {
  name: "priceInquiry",
  data() {
    return {
      formData: {
        SerialNo: "",
        OrderNo: "",
        StoreNo: "",
        MicHead: "",
        pageSize: 20,
        pageIndex: 1,
      },
      table_loading: false,
      tableData: {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0,
        list: [],
      },
      stateLIstanbul: [],
      packagingType: [],
    };
  },

  computed: {},

  mounted() {
    // this.getSelectMsg();
    // this.getPriceInquiry();
  },

  methods: {
    changeInput: function (e) {
      this.$forceUpdate();
    },
    async getSelectMsg() {
      const res = await innerface.priceInquiry.getSelectMsg();
      try {
        if (res.code == 0) {
          let arr = res.data;
          arr.forEach((item) => {
            if (item.type == "目的国家") {
              this.stateLIstanbul.push(item);
            } else if (item.type == "包装类型") {
              this.packagingType.push(item);
            }
          });
        } else {
          MessageTips(4, res.message);
        }
      } catch (error) {
        MessageTips(4, error);
      }
    },

    async getPriceInquiry() {
      this.table_loading = true;
      const res = await innerface.priceInquiry.getPriceInquiry(this.formData);
      try {
        if (res.code == 0) {
          this.tableData.list = res.data;
          this.tableData.totalCount = res.page.totalCount;
          this.table_loading = false;
        } else {
          this.table_loading = false;
          MessageTips(4, res.message);
        }
      } catch (error) {
        this.table_loading = false;
        MessageTips(4, error);
      }
    },

    query() {
      this.formData.pageIndex = 1;
      this.formData.pageSize = 20;
      if (this.formData.dateArray && this.formData.dateArray.length > 1) {
        this.formData.StartTime = this.formData.dateArray[0];
        this.formData.EndTime = this.formData.dateArray[1];
      } else {
        this.formData.StartTime = "";
        this.formData.EndTime = "";
      }
      this.getPriceInquiry();
    },

    handleSizeChange(val) {
      this.formData.pageIndex = 1;
      this.formData.pageSize = val;
      this.getPriceInquiry();
    },
    handleCurrentChange(val) {
      this.formData.pageIndex = val;
      this.formData.pageSize = 20;
      this.getPriceInquiry();
    },
  },
};
</script>

<style scoped lang="scss" scoped>
.flooter {
  width: 100%;
  display: flex;
  justify-content: center;
  justify-items: center;
}

.floatRight {
  margin-top: 3px;
  float: right;
}
.Waybilllist .time-select .new-label {
  min-width: 40px;
}
.Waybilllist .time-select .buswidth {
  width: calc(100% - 70px);
}
</style>
